import { render, staticRenderFns } from "./CloseTaskDialog.vue?vue&type=template&id=1086cf68"
import script from "./CloseTaskDialog.vue?vue&type=script&lang=ts"
export * from "./CloseTaskDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports